module.exports = __webpack_public_path__ + "static/media/puff-doble.a9d42764.png";